import { FC, useContext, useEffect } from "react";
import { BenefitSummaryType } from "./types";
import useFetch from "../../hooks/useFetch";
import { DownloadZipResponseType } from "../../pages/dashboard/types";
import { APIEndpoints } from "../../types/apiTypes";
import { LoaderContext } from "../../context/loaderContext";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { AuthContext } from "src/context/authContext";

const DetailPageInfo: FC<BenefitSummaryType> = ({ benefit_summary, coverage_summary, caseObject, isCasePage }): JSX.Element => {
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { isManufacturer } = useContext(AuthContext);




  const {
    data: downloadCaseData,
    error: downloadCaseError,
    mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData,
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData) {
        const { response, report_name } = downloadCaseData;
        downloadPdfFile(response, report_name);
      }
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadFileByCaseId = (insuranceId: string) => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    if (caseObject && caseObject.case_information)
      downloadRequestForm(
        {},
        {},
        isManufacturer ? { ref_id: insuranceId, type: "investigation", ref_type: "Insurance", skip_pi_investigation: true, benefit_type: caseObject?.case_information?.benefit_investigation?.benefit_type } : { ref_id: insuranceId, type: "investigation", ref_type: "Insurance", benefit_type: caseObject?.case_information?.benefit_investigation?.benefit_type }
      );
  };

  return (
    <div className="card rounded-1">
      <div className="card-header bg-success-subtle">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <h4 className={`mb-0 ${isCasePage ? `text-success` : `text-black`} `}>
            {isCasePage ? "Benefits Summary" : "Most Recent Benefits Information"}
          </h4>
          {isCasePage && caseObject && caseObject.case_information && (
            <button
              onClick={() => {
                downloadFileByCaseId(caseObject && caseObject.case_information &&
                  caseObject.case_information.benefit_investigation && caseObject.case_information.benefit_investigation.insurance_id)
              }}
              className="
                          btn btn-link fw-bold p-0 text-start" style={{ fontSize: '1.1rem' }}>
              Please click here to download the Benefits Investigations results form full details
            </button>
          )}

        </div>
      </div>

      <div className="card-body">
        {!isCasePage && (
          <p>Note: Please download the Benefits Investigations results forms for full details</p>
        )}

        {benefit_summary !== null && coverage_summary !== null ?
          <div>
            <div className="pb-4 container-fluid px-0">
              <div className="table-responsive border border-dark mb-2">
                <table className="table mb-0 benefits-table">
                  <thead>
                    {/* Row 1: Main Headings */}
                    <tr>
                      <th rowSpan={2} className="col-4 h3 px-2 fw-bold text-white background-color-3 align-middle border-0">
                        BENEFITS AT A GLANCE
                      </th>
                      <th colSpan={3} className="bg-white border-end border-dark text-center border-bottom-0 custom-border-end">
                        <h4 className="mb-0 fw-bold pb-2">Primary</h4>
                      </th>
                      <th colSpan={3} className="bg-white text-center border-bottom-0">
                        <h4 className="mb-0 fw-bold pb-2">Secondary</h4>
                      </th>
                    </tr>

                    {/* Row 2: Sub Headings */}
                    <tr>
                      {/* Primary sub headers */}
                      <th
                        className="px-3 text-center bg-white border border-dark border-start-0 border-end-0 border-top-0"
                        title="'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block"
                      >
                        Covered<sup>1</sup>
                      </th>
                      <th className="px-3 text-center bg-white border border-dark border-start-0 border-end-0 border-top-0">Coverage %</th>
                      <th className="px-3 text-center border border-dark border-start-0 border-end-0 border-top-0 custom-border-end bg-white">PA Required</th>

                      {/* Secondary sub headers */}
                      <th
                        className="px-3 text-center bg-white border border-dark border-start-0 border-end-0 border-top-0"
                        title="'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block"
                      >
                        Covered<sup>1</sup>
                      </th>
                      <th className="px-3 text-center bg-white border border-dark border-start-0 border-end-0 border-top-0">Coverage %</th>
                      <th className="px-3 text-center bg-white border border-dark border-start-0 border-end-0 border-top-0">PA Required</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <th className="h3 fw-bold text-white align-middle border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0" style={{ backgroundColor: "#ae91b2", width: '390px' }}>
                        QUTENZA/Medical
                      </th>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.qutenza_medical.primary_covered}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>
                          {!isManufacturer ? (
                            coverage_summary &&
                              ["number", "string"].includes(typeof coverage_summary.qutenza_medical.primary_coverage) ?
                              `${coverage_summary.qutenza_medical.primary_coverage}%`
                              : "%"
                          )
                            :
                            (
                              coverage_summary &&
                                Number(coverage_summary.qutenza_medical.primary_coverage) > 0
                                ? `${Number(coverage_summary.qutenza_medical.primary_coverage)}%`
                                : ""
                            )}
                        </b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-bottom-0 border-top-0 custom-border-end">
                        <h3><b>{coverage_summary?.qutenza_medical.primary_pa_req}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.qutenza_medical.secondary_covered}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>
                          {!isManufacturer ? (
                            coverage_summary &&
                              ["string", "number"].includes(typeof coverage_summary.qutenza_medical.secondary_coverage) ?
                              `${coverage_summary.qutenza_medical.secondary_coverage}%`
                              : "%"
                          ) :
                            (
                              coverage_summary &&
                                Number(coverage_summary.qutenza_medical.secondary_coverage) > 0
                                ? `${Number(coverage_summary.qutenza_medical.secondary_coverage)}%`
                                : ""
                            )}
                        </b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.qutenza_medical.secondary_pa_req}</b></h3>
                      </td>
                    </tr>
                    <tr>
                      <th className="h3 fw-bold text-white align-middle border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0" style={{ backgroundColor: "#59af7e", width: '390px' }}>
                        Administration
                      </th>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.administeration.primary_covered}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>
                          {!isManufacturer ? (
                            coverage_summary &&
                              ["string", "number"].includes(typeof coverage_summary.administeration.primary_coverage) ?
                              `${coverage_summary.administeration.primary_coverage}%`
                              : "%"
                          ) :
                            (
                              coverage_summary &&
                                Number(coverage_summary.administeration.primary_coverage) > 0
                                ? `${Number(coverage_summary.administeration.primary_coverage)}%`
                                : ""
                            )}
                        </b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-bottom-0 border-top-0 custom-border-end">
                        <h3><b>{coverage_summary?.administeration.primary_pa_req}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.administeration.secondary_covered}</b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>
                          {!isManufacturer ? (coverage_summary &&
                            ["string", "number"].includes(typeof coverage_summary.administeration.secondary_coverage) ?
                            `${coverage_summary.administeration.secondary_coverage}%`
                            : "%"
                          ) :
                            (
                              coverage_summary &&
                                Number(coverage_summary.administeration.secondary_coverage) > 0
                                ? `${Number(coverage_summary.administeration.secondary_coverage)}%`
                                : ""
                            )}
                        </b></h3>
                      </td>
                      <td className="text-center border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0">
                        <h3><b>{coverage_summary?.administeration.secondary_pa_req}</b></h3>
                      </td>
                    </tr>
                    <tr>
                      <th className="h3 fw-bold text-white align-middle border border-1 border-black border-start-0 border-end-0 border-bottom-0 border-top-0" style={{ backgroundColor: "#e5b465", width: '390px' }}>
                        QUTENZA/Pharmacy
                      </th>
                      <td className="text-center border-bottom-0">
                        <h3><b>{coverage_summary?.qutenza_pharmacy.primary_covered}</b></h3>
                      </td>
                      <td className="text-center border-bottom-0">
                        <h3><b>
                          {/* {!isManufacturer ?(
                              coverage_summary &&
                                ["string", "number"].includes(typeof coverage_summary.qutenza_pharmacy.primary_coverage) ?
                                `${coverage_summary.qutenza_pharmacy.primary_coverage}%`
                                : ""
                            ): */}
                          {(
                            coverage_summary &&
                              Number(coverage_summary.qutenza_pharmacy.primary_coverage) > 0
                              ? `${Number(coverage_summary.qutenza_pharmacy.primary_coverage)}%`
                              : ""
                          )}
                        </b></h3>
                      </td>
                      <td className="text-center border-end border-dark border-bottom-0 custom-border-end">
                        <h3><b>{coverage_summary?.qutenza_pharmacy.primary_pa_req}</b></h3>
                      </td>
                      <td className="text-center border-bottom-0">
                        <h3><b>{coverage_summary?.qutenza_pharmacy.secondary_covered}</b></h3>
                      </td>
                      <td className="text-center border-bottom-0">
                        <h3><b>
                          {/* {!isManufacturer ?(
                              coverage_summary &&
                                ["string", "number"].includes(typeof coverage_summary.qutenza_pharmacy.secondary_coverage) ?
                                `${coverage_summary.qutenza_pharmacy.secondary_coverage}%`
                                : "%"
                            ): */}
                          {(
                            coverage_summary &&
                              Number(coverage_summary.qutenza_pharmacy.secondary_coverage) > 0
                              ? `${Number(coverage_summary.qutenza_pharmacy.secondary_coverage)}%`
                              : ""
                          )}
                        </b></h3>
                      </td>
                      <td className="text-center border-bottom-0">
                        <h3><b>{coverage_summary?.qutenza_pharmacy.secondary_pa_req}</b></h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-md-5">
                  <h3><b>Qutenza Cost Savings Eligible? </b></h3>
                </div>
                <div className="col-md-7">
                  <h3><b>{coverage_summary?.cost_saving.saving}</b></h3>
                </div>
              </div>
            </div>
            <p className="fs-6">
              <sup>1</sup> <b>Note:</b> 'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block
            </p>
            {benefit_summary && benefit_summary.length > 0 && benefit_summary.map((item, index) => (
              <div className="card rounded-0 p-0 border-1 border-dark mb-3">
                <div className="card-header p-0">

                  <div className="container-fluid">
                    <div className="row text-white background-color-3">
                      <div className="col-md-12 pt-2">
                        <p className={"h3 my-2 text-white fw-bold"}>{item.heading}</p>
                      </div>
                    </div>

                    <div className="row bg-success-subtle">
                      <div className="col-12 col-lg-6">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="fw-bolder fs-4 text-black m-0 py-1">Insurance Name:</h4>
                          </div>
                          <div className="col-6">
                            <h4 className="fw-bolder fs-4 text-black m-0 py-1">{item.insurance_name}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="fw-bolder fs-4 text-black m-0 py-1">Insurance Type:</h4>
                          </div>
                          <div className="col-6">
                            <h4 className="fw-bolder fs-4 text-black m-0 py-1">{item.insurance_type}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <ul className={`nav nav-tabs ${item.out_comment && "d-none"}`} id="networkTab98724" role="tablist">
                    <li className="nav-item">
                      <a className="nav-link active fw-bold" id="inNetwork-tab98724" data-bs-toggle="tab" href="inNetworkTab" data-bs-target="#inNetworkTab" role="tab" aria-controls="inNetworkTab" aria-selected="true">In Network</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link fw-bold" id="outNetwork-tab98724" data-bs-toggle="tab" data-bs-target="#outNetworkTab" href="outNetworkTab" role="tab" aria-controls="outNetworkTab" aria-selected="false">Out of Network</a>
                    </li>
                  </ul>

                  <div className="tab-content" id="networkContent98724">
                    <div className="tab-pane show active container-fluid" id="inNetworkTab" role="tabpanel" aria-labelledby="inNetworkTab">

                      <div className="row">
                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>J7336 Coverage:</b></div>
                                  <div className="col-6">{item.coverage_J7336} %</div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>J7336 Copay:</b></div>
                                  <div className="col-6">$ {item.copay_J7336}  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Deductible:</b></div>
                                  <div className="col-6">$ {item.deductible}</div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-6">
                                {/* <div className="row">
                                  <div className="col-6"><b>Out of Packet Max:</b></div>
                                  <div className="col-6">$ {item.out_of_packet_max}</div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="row">
                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Admin Coverage:</b></div>
                                  <div className="col-6">{item.admin_coverage} %</div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Admin Copay:</b></div>
                                  <div className="col-6">${item.admin_copay}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Deductible Met:</b></div>
                                  <div className="col-6">$ {item.deductible_met}</div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-6">
                                {/* <div className="row">
                                  <div className="col-6"><b>Out of Pocket Met:</b></div>
                                  <div className="col-6">$ {item.out_of_pocket_met}</div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Office Coverage:</b></div>
                                  <div className="col-6">{item.office_coverage} %</div></div>
                              </div>
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Office Copay:</b></div>
                                  <div className="col-6">$ {item.office_copay}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 px-0 border border-1 border-dark">
                          <div className="container-fluid">
                            <div className="row p-0">
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                  <div className="col-6"><b>Deductible Remaining:</b></div>
                                  <div className="col-6">$ {item.deductible_remaining}</div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-6">
                                {/* <div className="row">
                                  <div className="col-6"><b>Out of Pocket Remaining:</b></div>
                                  <div className="col-6">$ {item.out_of_pocket_remaining}</div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row p-0 border border-1 border-dark">
                        <div className="col-md-3">
                          <b>Med Ben Notes:</b>
                        </div>
                        <div className="col-md-9">
                          {item.med_ben_notes}
                        </div>
                      </div>

                    </div>

                    <div className="tab-pane show container-fluid" id="outNetworkTab" role="tabpanel" aria-labelledby="outNetworkTab">
                      <div className="container-fluid">

                        <div className="row">
                          <div className="col-md-3"><b>Product Coverage:</b></div>
                          <div className="col-md-3">{item.product_coverage} %</div>
                          <div className="col-md-3"><b>Product Copay:</b></div>
                          <div className="col-md-3">$ {item.product_copay}</div>
                        </div>

                        <div className="row">
                          <div className="col-md-3"><b>Admin Coverage:</b></div>
                          <div className="col-md-3">{item.admin_coverage_2} %</div>
                          <div className="col-md-3"><b>Admin copay:</b></div>
                          <div className="col-md-3">$ {item.admin_copay_2}</div>
                        </div>

                        <div className="row">
                          <div className="col-md-3"><b>Office Coverage:</b></div>
                          <div className="col-md-3">{item.office_coverage_2} %</div>
                          <div className="col-md-3"><b>Office Copay:</b></div>
                          <div className="col-md-3">$ {item.office_copay}</div>
                        </div>

                        <div className="row">
                          <div className="col-md-3"><b>Deductible Met:</b></div>
                          <div className="col-md-3">$ {item.deductible_met_2}</div>
                          <div className="col-md-3"><b>Deductible:</b></div>
                          <div className="col-md-3">$ {item.deductible_2}</div>
                        </div>

                        {/* <div className="row">
                          <div className="col-md-3"><b>Out of Pocket Met:</b></div>
                          <div className="col-md-3">$ {item.out_of_pocket_met_2}</div>
                          <div className="col-md-3"><b>Out of Packet Max:</b></div>
                          <div className="col-md-3">$ {item.out_of_packet_max_2}</div>
                        </div> */}

                      </div>
                      <div className="row border border-1 border-dark">
                        <div className="col-md-3"><b>Medical Benefit Notes:</b></div>
                        <div className="col-md-9">{item.medical_benefit_notes}</div>
                      </div>
                    </div>

                    <div className="cotainer container-fluid background-color-3 border border-1 border-dark">
                      <p className="h3 my-2 text-white fw-bold">
                        {item.heading.toLowerCase().includes("primary") ? "PRIMARY" : "SECONDARY"} PHARMACY BENEFITS (SPECIALTY PHARMACY OPTION)
                      </p>
                    </div>


                    <div className="cotainer container-fluid border border-1 border-dark">
                      <div className="row">
                        <div className="col-md-4 border-end border-dark p-2">
                          <b>Insurance Company:</b> {item.insurance_name}
                        </div>
                        <div className="col-md-4 border-end border-dark  border-start p-2">
                          <b>Member ID:</b> {item.member_id}
                        </div>
                        <div className="col-md-4 border-end border-dark border-start  p-2">
                          <b>Group Number:</b>{item.group_number}
                        </div>
                        {/* <div className="col-md-9">
                          {item.pharmacy_benefit_manager}
                        </div> */}
                      </div>
                    </div>
                    <div className="cotainer container-fluid border border-1 border-dark">
                      <div className="row">
                        <div className="col-md-3 border-end border-dark  p-2">
                          <b>Pharmacy Benefit Manager:</b> {item.pharmacy_benefit_manager}
                        </div>
                        <div className="col-md-3 border-end border-dark border-start p-2">
                          <b>Prior Authorization Needed for National Drug Code:</b>
                          <div className="radio-options">
                            <label className="me-3">
                              <input
                                type="radio"
                                checked={item.pa_ndc === true}
                                readOnly
                              /> Yes
                            </label>

                            <label className="me-3">
                              <input
                                type="radio"
                                checked={item.pa_ndc === false}
                                readOnly
                              /> No
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 border-end border-dark border-start p-2">
                          <b>Prior Authorization Needed for Administration:</b>
                          <div className="radio-options">
                            <label className="me-3">
                              <input
                                type="radio"
                                checked={item.pa_nfa === true}
                                readOnly
                              /> Yes
                            </label>

                            <label className="me-3">
                              <input
                                type="radio"
                                checked={item.pa_nfa === false}
                                readOnly
                              /> No
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 border-end border-dark border-start p-2">
                          <b>Medication Copay:</b> {item.medication_copay}
                        </div>
                      </div>
                    </div>
                    <div className="cotainer container-fluid border border-1 border-dark">
                      <div className="row">
                        <div className="col-md-3">
                          <b>Rx Benefit Notes:</b>
                        </div>
                        <div className="col-md-9">
                          {item.rx_bene_notes}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>
          :
          <div>
            <h1 className={"fw-bold"}>Benefits are still pending for this case.</h1>
          </div>
        }
      </div>
    </div>
  );
};

export default DetailPageInfo;
